import { TextareaProps } from "@chakra-ui/react";
import { useColorModeValue } from '@chakra-ui/react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";

type Props = {
  meta: FormInputMeta;
  register?: any;
  hasError?: any;
} & TextareaProps;

export default function CustomTextArea({
  meta,
  register,
  hasError,
  ...rest
}: Props) {

  const bg = useColorModeValue('white', 'gray.800');

  return (
    <>
      {register ? <CC.Textarea
        autoComplete="off"
        {...rest}
        bg={bg}
        type={meta?.type}
        placeholder={meta?.placeholder}
        disabled={meta?.disabled} value={meta?.value}
        {...register}
      /> : <CC.Textarea
        autoComplete="off"
        bg={bg}
        type={meta?.type}
        name={meta?.name}
        placeholder={meta?.placeholder}
        disabled={meta?.disabled}
        value={meta?.value}
        onChange={meta.onChange}
        {...rest}
      />}
      {meta?.name && hasError && <CC.FormErrorMessage>{hasError.message}</CC.FormErrorMessage>}
    </>
  );
}
